import { m } from 'framer-motion';
import { useState, useEffect } from 'react';
// @mui
import { alpha } from '@mui/material/styles';
import Box from '@mui/material/Box';
import {
  Button,
  FormControl,
  Typography,
  MenuItem,
  Grid,
  Modal,
  Divider,
  Select, Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
  TextField,
  IconButton,
 
} from '@mui/material';

import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import FormProvider, { RHFTextField } from 'src/components/hook-form';
import Stack from '@mui/material/Stack';
import { useNavigate } from 'react-router';
import { FaRegUser } from "react-icons/fa";
import { FiLogOut } from "react-icons/fi";
import * as Yup from 'yup';
import { MdLockReset } from "react-icons/md";
import axios, { endpoints } from 'src/utils/axios';
import Avatar from '@mui/material/Avatar';
import LoadingButton from '@mui/lab/LoadingButton';
// routes
import { IoCloseCircleOutline } from 'react-icons/io5';
import InputAdornment from '@mui/material/InputAdornment';
import { useRouter } from 'src/routes/hook';
import { useBoolean } from 'src/hooks/use-boolean';
// hooks
import Iconify from 'src/components/iconify';
import { paths } from 'src/routes/paths';
import { useSnackbar } from 'src/components/snackbar';
import { useMockedUser } from 'src/hooks/use-mocked-user';
// auth
import { useAuthContext } from 'src/auth/hooks';
// components
import { varHover } from 'src/components/animate';
import CustomPopover, { usePopover } from 'src/components/custom-popover';


// ----------------------------------------------------------------------

// const OPTIONS = [
//   {
//     label: 'Home',
//     linkTo: '/',
//   },
//   {
//     label: 'Profile',
//     linkTo: '/#1',
//   },
//   {
//     label: 'Settings',
//     linkTo: '/#2',
//   },
// ];

// ----------------------------------------------------------------------

export default function AccountPopover() {
  const router = useRouter();
  const auth = useAuthContext();
  const ids =auth.user?.id
  const role = auth.user?.roleType;

  const [detail, setDetail] = useState({
    name: '',
    username:'',
    email: '',
    countryCode:'+91',
    mobile: '',
    password: '',
    status: 'Active', 
    roleType: null,    
  });

  const { enqueueSnackbar } = useSnackbar();
  const [open, setOpen] = useState(false);
    const passwordVisibility = useBoolean();
    const confirmPasswordVisibility = useBoolean();
   // Validation Schema for Reset Password
    const ResetPasswordSchema = Yup.object().shape({
      newPassword: Yup.string()
        .required('New password is required')
        .min(4, 'Password must be at least 4 characters')
        .max(20, 'Password must be at most 20 characters'),
      confirmPassword: Yup.string()
        .oneOf([Yup.ref('newPassword')], 'Passwords must match')
        .required('Please confirm your password'),
    });
    const methods = useForm({
      resolver: yupResolver(ResetPasswordSchema),
    });
  
    const {
      handleSubmit,
      clearErrors,
      reset,
      formState: { isSubmitting },
    } = methods;

    const onSubmit = handleSubmit(async (data) => {
      if (data) {
        if (data.confirmPassword === data.newPassword) {
         const formdata={
          "userId": auth.user.id,
          "newPassword":data.newPassword
         }
  
          try {
            const response = await axios.post(`${endpoints.auth.resetPasswords}`,formdata);
         
            if (response) {
               setOpenViewDialog(false)
               reset()
              popover.onClose();
              enqueueSnackbar(response.data.message, { variant: 'success' });
            }
          } catch (error) {
         
            enqueueSnackbar(error.message, { variant: 'error' });
          } 
        }
      }
      else{
        enqueueSnackbar("Token is required", { variant: 'error' });
      }
    
    });

 const navigate =useNavigate();
 const [openProfile,setOpenProfile] =useState(false)
 const [openViewDialog,setOpenViewDialog] =useState(false)
   const redirectToProfile = (row) => {
      navigate(paths.dashboard.user.profile);
    };
  // Close the dialog
 const handleCloseViewDialog = () => {
  setOpenViewDialog(false)
  reset()
      clearErrors();
 };

 const handleCloseProfileDialog = () => {
  setOpenProfile(false)
      clearErrors();
 };

 const handleOpenProfileDialog = () => {
  setOpenProfile(true)

  axios.get(`${endpoints.user.getuser}${ids}`)
  .then((response) => {

    let roleName = '';
    if (response.data.user.roleType === 1) {
      roleName = "Super Admin";
    } else if (response.data.user.roleType === 2) {
      roleName = "Counsellor";
    } else if (response.data.user.roleType === 3) {
      roleName = "Admin";
    } else if (response.data.user.roleType === 4) {
      roleName = "Trainer";
    } 
         setDetail({
           id: response.data.user.id,
           name: response.data.user.username,
           username:response.data.user.name,
           countryCode:response.data.user.countryCode,
           roleType:roleName,
           mobile: response.data.user.mobile,
           email: response.data.user.email,
           status: response.data.user.status,
           createdAt: response.data.user.createdAt,
          //  createdAt: response.data.user.createdAt,
           createdBy: response.data.user.createdBy,
           updatedAt: response.data.user.updatedAt,
           updatedBy: response.data.user.updatedBy,
         });
  })
  .catch((error) => {
// console.log("Error",error.message);
  });
      clearErrors();
 };


  const { user } = useMockedUser();

  const { logout } = useAuthContext();

  const popover = usePopover();

  const handleLogout = async () => {
    try {
      await logout();
      popover.onClose();
      router.replace('/login');
    } catch (error) {
      console.error(error);
    }
  };
 const handleopen =async () => {
  try {
    setOpenViewDialog(true)
  } catch (error) {
    setOpenViewDialog(false)
    console.error(error);
  }
};
  // const handleClickItem = (path) => {
  //   popover.onClose();
  //   router.push(path);
  // };
  const renderForm = (
    <FormProvider methods={methods} onSubmit={onSubmit}>
      <Stack spacing={2}>
        <Typography variant="body1">
          New Password <span style={{ color: 'red' }}>*</span>
        </Typography>
        <RHFTextField
          name="newPassword"
          label="Enter your new password"
        size="small" 
          type={passwordVisibility.value ? 'text' : 'password'}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={passwordVisibility.onToggle} edge="end">
                  <Iconify
                    icon={passwordVisibility.value ? 'solar:eye-bold' : 'solar:eye-closed-bold'}
                  />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />

        <Typography variant="body1">
          Confirm Password <span style={{ color: 'red' }}>*</span>
        </Typography>
        <RHFTextField
          name="confirmPassword"
          label="Confirm your new password"
          size="small" 
          type={confirmPasswordVisibility.value ? 'text' : 'password'}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={confirmPasswordVisibility.onToggle} edge="end">
                  <Iconify
                    icon={
                      confirmPasswordVisibility.value ? 'solar:eye-bold' : 'solar:eye-closed-bold'
                    }
                  />
                </IconButton>
              </InputAdornment>
            ),
   
          }}
        />

       <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 0 }}>
  <LoadingButton
    color="primary"
    size="large"
    type="submit"
    variant="contained"
    loading={isSubmitting}
    sx={{
      height: 38,
      backgroundImage: 'linear-gradient(91.3deg, #7068ff 15.7%, #ba5aee 74.1%)',
    }}
  >
    Reset Password
  </LoadingButton>
</Box>

       
       
      </Stack>
    </FormProvider>
  );

  return (
    <>
      <IconButton
        component={m.button}
        whileTap="tap"
        whileHover="hover"
        variants={varHover(1.05)}
        onClick={popover.onOpen}
        sx={{
          width: 38,
          height: 38,
          background: (theme) => `linear-gradient(135deg, ${theme.palette.primary.light} 0%, ${theme.palette.primary.main} 100%)`,
          ...(popover.open && {
            background: (theme) =>
              `linear-gradient(135deg, ${theme.palette.primary.light} 0%, ${theme.palette.primary.main} 100%)`,
          }),
        }}
      >
        <Avatar
          src={user?.photoURL}
          alt={user?.displayName}
          sx={{
            width: 34,
            height: 34,
            color: (theme) => theme.palette.background.paper,
            border: (theme) => `solid 2px ${theme.palette.background.default}`,
          }}
        />
      </IconButton>

      <CustomPopover open={popover.open} onClose={popover.onClose} sx={{ width: 200, p: 0 }}>
        <Box sx={{ p: 2, pb: 1.5 }}>
          <Typography noWrap  sx={{ fontWeight: '500', color: '#343434',fontSize:'14px',mb:1 }}>
            {user?.displayName}
          </Typography>
          <Typography sx={{ fontWeight: '500', color: '#a7a7a7',fontSize:'12px',mt:1}} noWrap>
            {user?.mobile}
          </Typography>
          <Typography sx={{ fontWeight: '500', color: '#a7a7a7',fontSize:'12px',mt:1}} noWrap>
            {user?.email}
          </Typography>
         
        </Box>

        <Divider sx={{ borderStyle: 'dashed' }} />

        {/* <Stack sx={{ p: 1 }}>
          {OPTIONS.map((option) => (
            <MenuItem key={option.label} onClick={() => handleClickItem(option.linkTo)}>
              {option.label}
            </MenuItem>
          ))}
        </Stack> */}

        <Divider sx={{ borderStyle: 'dashed' }} />
 <MenuItem
          onClick={handleopen}
          sx={{ mt:1,ml:1, fontWeight: '500', color: 'primary.main',fontSize:'12px' }}
         
        >
        <Box sx={{ fontSize: '22px' }}>
  <MdLockReset />
</Box>
  <Typography  sx={{ mt: -1, fontWeight: '600', color: 'primary.main',fontSize:'12px' }}> Reset Password</Typography>
        </MenuItem>
         <Divider sx={{ borderStyle: 'dashed' }} />
        <MenuItem
          onClick={handleLogout}
          sx={{ mt:1,ml:1, fontWeight: '500', color: 'error.main',fontSize:'12px' }}
         
        >
        <Box sx={{ fontSize: '20px' }}>
  <FiLogOut />
</Box>
  <Typography  sx={{ mt: -1, fontWeight: '600', color: 'error.main',fontSize:'12px' }}> Logout</Typography>
        </MenuItem>
        <Modal
           sx={(theme) => ({
           pt: 1,
           display: 'flex',
           alignItems:'center',
           flexDirection: 'row',
           width: {
             xs: '100%', 
             sm: '55%',  
             lg: '55%',  
           },
           margin: '0 auto',
          })}
          open={openViewDialog}
           onClose={handleCloseViewDialog}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          
               <Box sx={{
      position: 'fixed',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      backgroundColor: 'white',
      padding: 5,
      borderRadius: 2,
      boxShadow: 3,
      // zIndex: 9999,
      width: {
        sm:'420px',
        xs:"330px"
      },
     
    }}>
        <IconButton
      onClick={handleCloseViewDialog}
      sx={{
        position: 'absolute',
        top: 8,
        right: 8,
        color: '#888',
        zIndex: 10,
      }}
    >
      <IoCloseCircleOutline size={24} />
    </IconButton>
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <Box component="img" src="/logo/finxllogo.png" sx={{ width: 200, height: 70 }} />
      </Box>

      <Stack spacing={1} sx={{ mb: 1 }}>
        <Typography variant="h4" sx={{mt:2}}>Reset Password</Typography>
        <Typography variant="subtitle1" sx={{ color: 'grey',mb:1,mt:-1.5 }}>
          Enter and confirm your new password to reset your account password.
        </Typography>
      </Stack>

      {renderForm}

      <Stack spacing={1} sx={{ mt: 2 }}>
        <Typography variant="subtitle2" sx={{ color: 'grey', textAlign: 'center' }}>
          Copyright © 2024 Finxl. Crafted by Deepminds Infotech Pvt. Ltd.
        </Typography>
      </Stack>
    </Box>
{/* <Box sx={{
  display: 'flex',
  justifyContent: 'flex-end',
  mt: 3,
}}>
  <Button
    variant="contained"
    onClick={handleCloseViewDialog}
    sx={{
      padding: '8px 16px', 
      mb:2,
      backgroundColor: '#eaeaea', 
      border: '1px solid #eaeaea',
      color: '#404040', 
      '&:hover': {
        backgroundColor: '#d6d6d6',
        borderColor: '#d6d6d6',
      },
    }}
  >
    Close
  </Button>
</Box> */}
       
        </Modal>

        <Modal
           sx={(theme) => ({
           pt: 1,
           display: 'flex',
           alignItems:'center',
           flexDirection: 'row',
           width: {
             xs: '100%', 
             sm: '80%',  
             lg: '40%',  
           },
           margin: '0 auto',
          })}
          open={openProfile}
           onClose={handleCloseViewDialog}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={{
position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '80%',
  bgcolor: 'background.paper',
 
  borderRadius: '10px',
  boxShadow: 24,
  p:3,

          }}>
            <Typography id="modal-modal-title" variant="h5" component="h2" sx={{ml:3,mt:2 }}>
             Profile Details
            </Typography>
        


<TableContainer sx={{ mt: 2,border:'1px solid #DBD9FC',borderRadius:'5px'}}>
  <Table>
    <TableBody>
      <TableRow sx={{ borderBottom: '0.2px solid #DBD9FC' }}>
        <TableCell  sx={{  fontWeight: 'bold', backgroundColor: '#f3f2ff'  }}>Name :</TableCell>
        <TableCell>{detail.name}</TableCell>
      </TableRow>
      <TableRow sx={{ borderBottom: '0.2px solid #DBD9FC' }}>
        <TableCell  sx={{ fontWeight: 'bold', backgroundColor: '#f3f2ff'  }}>Email :</TableCell>
        <TableCell>{detail.email}</TableCell>
      </TableRow>
      <TableRow sx={{ borderBottom: '0.2px solid #DBD9FC' }}>
        <TableCell  sx={{ fontWeight: 'bold', backgroundColor: '#f3f2ff' }}>Mobile :</TableCell>
        <TableCell>{detail.countryCode} {detail.mobile}</TableCell>
      </TableRow>
      <TableRow sx={{ borderBottom: '0.2px solid #DBD9FC' }}>
        <TableCell  sx={{ fontWeight: 'bold', backgroundColor: '#f3f2ff' }}>Role :                              </TableCell>
        <TableCell>
        <Button
              style={{
                fontSize: 12,
                fontWeight: 500,
                color: '#7068ff',
                padding: '6px 10px',
                backgroundColor: '#e2e1ff',
                borderRadius: '5px',
              }}
            >
            
              {detail.roleType}
            </Button>
        </TableCell>
      </TableRow>
      <TableRow sx={{ borderBottom: '0.2px solid #DBD9FC' }}>
        <TableCell  sx={{ fontWeight: 'bold', backgroundColor: '#f3f2ff' }}>Status :</TableCell>
        <TableCell>
      
        <Button
              style={{
                fontSize: 12,
                fontWeight: 500,
                color: detail.status === 'Active' ? '#28c76f' : '#ff2c2c',
                padding: '6px 10px',
                backgroundColor: detail.status === 'Active' ? '#ddf6e8' : '#ffbfbf',
                borderRadius: '5px',
              }}
            >
              {detail.status}
            </Button>
        </TableCell>
      </TableRow>
      <TableRow sx={{ borderBottom: '0.2px solid #DBD9FC' }}>
        <TableCell sx={{ fontWeight: 'bold',backgroundColor: '#f3f2ff' }}>Created On:</TableCell>
        <TableCell>{detail.createdAt}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell sx={{ fontWeight: 'bold',backgroundColor:'#f3f2ff' }}>Updated On:</TableCell>
        <TableCell>{detail.updatedAt}</TableCell>
      </TableRow>
    </TableBody>
  </Table>
</TableContainer>

<Box sx={{
  display: 'flex',
  justifyContent: 'flex-end',
  mt: 3,
}}>
  <Button
    variant="contained"
    onClick={handleCloseProfileDialog}

    sx={{
      padding: '8px 16px', 
      backgroundColor: '#eaeaea', 
      border: '1px solid #eaeaea',
      color: '#404040', 
      '&:hover': {
        backgroundColor: '#d6d6d6',
        borderColor: '#d6d6d6',
      },
    }}
  >
    Close
  </Button>
</Box>
          </Box>
        </Modal>
      </CustomPopover>
    </>
  );
}
